module.exports = __webpack_public_path__ + "img/modal-red.f75643b9.svg";